"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _StyledTypography = require("../../../StyledTypography");

var _Icon = _interopRequireDefault(require("../../../Icon"));

var _Elements = require("../../Elements");

var _Elements2 = require("./Elements");

var EmptyState = function EmptyState(_ref) {
  var site = _ref.site;
  return /*#__PURE__*/_react["default"].createElement(_Elements2.EmptyStateBox, {
    flex: true,
    align: "center",
    column: true
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "photoLibrary"
  }), /*#__PURE__*/_react["default"].createElement(_StyledTypography.HeadingMedium, {
    portfolioFontFamily: true,
    portfolioForeground1: true,
    my: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.empty_state.title"
  })), /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    portfolioForeground1: true,
    center: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.empty_state.sub_title",
    values: {
      site: site
    }
  })));
};

EmptyState.defaultProps = {
  site: '[Site title]'
};
EmptyState.propTypes = {
  site: _propTypes["default"].string
};
var _default = EmptyState;
exports["default"] = _default;